import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import BankAddEdit from './AgentAddEdit';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import AddIcon from '@material-ui/icons/Add';
import { TablePagination, TextField } from '@mui/material';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { LoadingButton } from '@mui/lab';
import SendIcon from '@material-ui/icons/Send';
import AmountToSend from './AmountToSend';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 330px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '260px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '600px',
  },
  alignCenter: {
    textAlign: 'center',
  },
  // contentPadding:{
  //   '&.MuiDialogContent-root':{
  //     padding:'8px 62px'
  //   }
  // }
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
}));

const Agent = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [list, setList] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [addDialog, setAddDialog] = useState(false);

  const [agentDialog, setAgentDialog] = useState(false);
  const [agent_id, set_agent_id] = useState('');

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [count, setCount] = useState(0);

  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = () => {
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const openAgentDialog = item => {
    setDetailViewItem(item);

    setAgentDialog(true);
  };
  const closeAgentDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAgentDialog(false);
  };

  const handleSearch = () => {
    getList();
  };
  const handleClear = () => {
    setFirstName('');
    setLastName('');
    setName('');
    setMobileNumber('');
    setEmail('');
    getListAll();
  };

  const getListAll = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/agent?page=${page}&size=${perPage}`;
    let url = new URL(uri);

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        // console.log('response', response);
        setList(response.data.data.content);
        setCount(response.data.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        // console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
    setLoading(false);
  };

  const getList = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/agent?page=${page}&size=${perPage}`;
    let url = new URL(uri);
    url.searchParams.append('firstName', firstName.trim());
    url.searchParams.append('lastName', lastName.trim());
    url.searchParams.append('name', name.trim());
    url.searchParams.append('mobileNumber', mobileNumber.trim());
    url.searchParams.append('email', email.trim());

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        // console.log('response', response);
        setList(response.data.data.content);
        setCount(response.data.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        // console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
    setLoading(false);
  };
  const getById = async id => {
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .get(`/api/v1/private/agent/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        // console.log('res', response);
        setEditObj(response.data.data);
        openAddDialog();
      })
      .then()
      .catch(function(error) {
        // handle error
        // console.log(error);
        // setMessage(error.response.data.error);
      });
  };
  const handleDelete = async () => {
    setLoadingDelete(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/agent/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        // console.log('response', response);
        let newList = list.filter(res => res.id !== deleteId);
        // console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
      })
      .catch(function(error) {
        // handle error
        // console.log(error);
      });
    setLoadingDelete(true);
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        // console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 20; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  useEffect(() => {
    getCountry();
  }, []);

  useEffect(() => {
    getList();
  }, [page]);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">AGENT LIST</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>

        <Grid item md={3}>
          <TextField
            label="First Name"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Last Name"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={lastName}
            onChange={e => setLastName(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Company"
            variant="outlined"
            fullWidth
            size="small"
            className={classes.inputStyle}
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="Mobile Number"
            variant="outlined"
            fullWidth
            size="small"
            className={`${classes.marginStyle} ${classes.inputStyle}`}
            value={mobileNumber}
            onChange={e => setMobileNumber(e.target.value)}
          />
        </Grid>
        <Grid item md={3}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={handleSearch}
            startIcon={<SearchOutlinedIcon />}>
            Search
          </Button>

          <IconButton onClick={handleClear} size="small" style={{ marginLeft: 15, background: '#ddd' }}>
            <CloseOutlinedIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader aria-label="simple table">
                <TableHead className={classes.tableHeadStyle}>
                  <TableRow>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Company</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Phone Number</TableCell>
                    <TableCell align="left">Address</TableCell>
                    {/* <TableCell align="center">Status</TableCell> */}
                    <TableCell align="center" className={classes.cellWidth}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBodyStyle}>
                  {list.length > 0 && !loading
                    ? list.map((row, i) => (
                        <TableRow hover key={i}>
                          <TableCell align="left" scope="row">
                            {row.firstName} {row.lastName}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.name}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.email && row.email}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.mobileNumber}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.address}
                          </TableCell>

                          {/* <TableCell align="center">
                          <img src={row.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                        </TableCell> */}
                          <TableCell align="center">
                            <Button size="small" variant="outlined" onClick={() => openAgentDialog(row)}>
                              Topup
                            </Button>
                            <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton
                              className={classes.editButton}
                              onClick={() => {
                                setEditIndexNo(i);
                                getById(row.id);
                                // openAddDialog();
                                // setEditObj(row);
                              }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => {
                                handleDeleteDialogClickOpen();
                                setDeleteId(row.id);
                              }}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                  {!loading && list.length < 1 ? (
                    <TableRow>
                      <TableCell colSpan="10" style={{ textAlign: 'center' }}>
                        {message}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {loading && pageLoading()}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              rowsPerPageOptions={[]}
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
            />
          </Paper>
        </Grid>
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <TableContainer style={{ marginBottom: '40px' }}>
                <div className={classes.titleDiv}>
                  <div className={classes.iconDiv}>
                    <IconButton
                      style={{ background: 'gainsboro' }}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={handleCloseDetailView}>
                      <Clear fontSize="inherit" />
                    </IconButton>
                  </div>

                  <Typography variant="h1" className={` ${classes.alignCenter}`}>
                    Details
                  </Typography>
                </div>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell scope="row" />
                      <TableCell align="right" />
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Company Name</TableCell>
                      <TableCell align="right">{detailViewItem.name}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">First Name</TableCell>
                      <TableCell align="right">{detailViewItem.firstName}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Last Name</TableCell>
                      <TableCell align="right">{detailViewItem.lastName}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Business Street</TableCell>
                      <TableCell align="right">{detailViewItem.businessStreet}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Business Country</TableCell>
                      <TableCell align="right">{detailViewItem.businessCountry}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Postal Zip</TableCell>
                      <TableCell align="right">{detailViewItem.postalZip}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Mobile Number</TableCell>
                      <TableCell align="right">{detailViewItem.mobileNumber}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Business Email</TableCell>
                      <TableCell align="right">{detailViewItem.email}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Type Of Business</TableCell>
                      <TableCell align="right">{detailViewItem.typeOfBusiness}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Agent Find Us From</TableCell>
                      <TableCell align="right">{detailViewItem.agentFindUsFrom}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Address</TableCell>
                      <TableCell align="right">{detailViewItem.address}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Open Time</TableCell>
                      <TableCell align="right">{detailViewItem.openTime}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Close Time</TableCell>
                      <TableCell align="right">{detailViewItem.closeTime}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Status</TableCell>
                      <TableCell align="right">
                        {detailViewItem.status ? (
                          <Typography variant="h6" style={{ color: 'green' }}>
                            Available
                          </Typography>
                        ) : (
                          <Typography variant="h6" style={{ color: 'red' }}>
                            Not Available
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <BankAddEdit
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Amount to send Dialog start============================== */}

      <div>
        <Dialog
          open={agentDialog}
          onClose={closeAgentDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <AmountToSend closeAgentDialog={closeAgentDialog} detailViewItem={detailViewItem} allCountry={allCountry} />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogTitle>
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <LoadingButton loading={loadingDelete} color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default Agent;
